import React, { ReactNode } from 'react';

import { Stack, Typography } from '@mui/material';
import { EAvatarTypes } from 'shared/types/card.interface';

import { IParticipantData } from 'shared/types/challenges.interface';
import { Avatar } from 'components/Avatar/Avatar';
import { CustomMuiIcon } from 'assets/images/icons/customMuiIcons';

interface ICardUserInfo {
  user: IParticipantData;
  children?: ReactNode;
  isFullCard?: boolean;
}

export const CardUserInfo: React.FunctionComponent<ICardUserInfo> = ({
  user,
  isFullCard,
  children,
}) => (
  <Stack
    justifyContent="center"
    alignItems="center"
    sx={{
      ...(isFullCard
        ? {
            position: { md: 'relative', sm: 'static', xs: 'static' },
            top: {
              lg: 'calc(50% - 84px)',
              md: 'calc(50% - 68px)',
            },
          }
        : { alignSelf: 'flex-start' }),
      width: {
        lg: isFullCard ? '40%' : 'calc((100% - 16px - 47px) / 2)',
        md: isFullCard ? '40%' : 'calc((100% - 16px - 28px) / 2)',
        sm: isFullCard ? '40%' : 'calc((100% - 16px - 28px) / 2)',
        xs: isFullCard ? '40%' : 'calc((100% - 16px - 28px) / 2)',
      },
    }}
  >
    {user?.id && (user?.first_name?.length || user?.last_name?.length) ? (
      <>
        <Avatar
          type={isFullCard ? EAvatarTypes.FullCard : EAvatarTypes.SmallCard}
          isFullCard
          firstName={user?.first_name}
          lastName={user?.last_name}
        />
        <Typography
          variant={isFullCard ? 'h4' : 'h5'}
          color={isFullCard ? 'primary.contrastText' : 'secondary.main'}
          textAlign="center"
          sx={{
            fontSize: {
              lg: isFullCard ? '20px' : '14px',
              md: isFullCard ? '20px' : '14px',
              sm: isFullCard ? '16px' : '14px',
              xs: isFullCard ? '16px' : '14px',
            },
            marginTop: isFullCard ? '12px' : '4px',
            minHeight: '34px',
          }}
        >
          {`${user?.first_name} ${user?.last_name}`}
        </Typography>
      </>
    ) : (
      <>
        <CustomMuiIcon
          type={isFullCard ? 'icon-unknown-opponent-full-card' : 'icon-unknown-opponent'}
          sx={{
            color: 'primary.contrastText',
            background: 'none',
            borderRadius: '50%',
            backgroundColor: 'none',
            marginBottom: '12px',
            fontSize: {
              lg: isFullCard ? '120px' : '80px',
              md: isFullCard ? '100px' : '60px',
              sm: isFullCard ? '85px' : '60px',
              xs: isFullCard ? '80px' : '60px',
            },
          }}
        />
        {isFullCard && children}
      </>
    )}
  </Stack>
);
